import type { SVGProps } from "react";

export function IconBlueCart(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_8880_5903)">
        <rect opacity="0.5" width="56" height="56" fill="#E4E7FC" />
        <path
          d="M25 16H37V28H25V16Z"
          fill="#5486FA"
          stroke="#5486FA"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          d="M40 32H20V16H16M31 16V19M41 37.5C41 38.8807 39.8807 40 38.5 40C37.1193 40 36 38.8807 36 37.5C36 36.1193 37.1193 35 38.5 35C39.8807 35 41 36.1193 41 37.5ZM24 37.5C24 38.8807 22.8807 40 21.5 40C20.1193 40 19 38.8807 19 37.5C19 36.1193 20.1193 35 21.5 35C22.8807 35 24 36.1193 24 37.5Z"
          stroke="#1C1719"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_8880_5903">
          <rect width="56" height="56" rx="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
